import { api, ApiRequestConfig } from 'api';
import { FetchModelProps, ModelJson } from 'features/page-model/types';
import { HttpErrorResponse, ThunkConfig } from 'types/common';

export type GetModelParams = {
  host: string;
  params: FetchModelProps;
  config?: ApiRequestConfig;
};

export const getModel = async (
  { host, params, config }: GetModelParams,
  { rejectWithValue }: ThunkConfig,
) => {
  try {
    return await api.get<ModelJson, FetchModelProps>(`${host}/get-model`, params, config);
  } catch (error) {
    const err = error as HttpErrorResponse;
    return rejectWithValue(err?.code || err?.status);
  }
};
